import { Switch, SwitchProps } from "@mui/material"
import classname from "classnames"
import "./toggle.scss"

export default function Toggle(props: SwitchProps) {
  return (
    <Switch
      className={classname("ToggleCont", props.className)}
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...props}
    />
  )
}
